import React, { useRef, useEffect, useState } from "react";
import Paper from "@mui/material/Paper"
import { Stack } from "@mui/material";
import { Popover, PopoverPaused } from "./popover";
import _ from "lodash";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { store } from "../../store/store";
import { defaultImageAnalysisState } from "../../store/context/imageAnalysisSlice";
import { imageAnalysisActions } from "../../store/store";
import DownloadIcon from '@mui/icons-material/Download';
import { saveJson } from "../scripts/scripts";
import './image.css'
import axios from "axios";
export const BootstrapTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: "rgba(32, 38, 43, 0.95)",
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "rgba(32, 38, 43, 0.95)",
    maxWidth: "15rem"
  },
}));

// const get_image_url = (image) => {
//   return `https://caiproduction002.blob.core.windows.net/ira/audit_images/` + image + `?sv=2020-08-04&ss=bfqt&srt=sco&sp=rwdlacupitfx&se=2050-05-06T01:59:09Z&st=2022-05-05T17:59:09Z&spr=https&sig=SsFQp5OkIrSG9gVnf4V9F4Vi463mtW25t0Vw2SQzVIM%3D`;
// }
const get_image_url = async (image) => {
	try {
		const urlData = await axios.post("/get_context/getImageURL", {
			"imageName": image,
			"folderName":"audit_images"
		})
		const imageUrl = urlData.data;
		console.log(imageUrl,"LINE 51")
		return imageUrl
	} catch (error) {
		console.error("Error fetching image:", error.message);
		return null;
	}
};

const get_thumbnail_url = (thumbnail) => {
  return "https://caiproduction002.blob.core.windows.net/ira/iat/thumbnails/" + thumbnail + "?sv=2020-08-04&ss=bfqt&srt=sco&sp=rwdlacupitfx&se=2050-05-06T01:59:09Z&st=2022-05-05T17:59:09Z&spr=https&sig=SsFQp5OkIrSG9gVnf4V9F4Vi463mtW25t0Vw2SQzVIM%3D"
}

const get_rgb = (color) => {
  const r = color.replace(/ /g, "").split(",")[0].split("(")[1];
  const g = color.replace(/ /g, "").split(",")[1];
  const b = color.replace(/ /g, "").split(",")[2].split(")")[0];

  return [r, g, b];
}

export default function ImageAnalysis(props) {
  console.log('dimss', props.dim)
  const canvasRef = useRef(null);
  const dispatch = useDispatch();
  const imgNo = props.imgNo;
  const [open, setOpen] = useState(false);
  const [cursorDim, setCursorDim] = useState([0, 0]);
  const [popoverData, setPopoverData] = useState([]);
  const [popoverPaused, setPopoverPaused] = useState(false);
  const [popoverPausedCoords, setPopoverPausedCoords] = useState([]);
  const [pausedPopoverData, setPausedPopoverData] = useState([]);
  const [cropCoords, setCropCoords] = useState([0, 0, 0, 0]);
  const [pausedCropCoords, setPausedCropCoords] = useState([0, 0, 0, 0]);
  const [popoverLiveDim, setPopoverLiveDim] = useState([0, 0]);
  const [isBlurredImage, setIsBlurredImage] = useState(false);
  const [image, setImage] = useState(null);


  // extracting store info
  console.log(props.imageDetails,"63");
  const address = props.imageDetails.storeInfo.split("/")[3];
  const session_audit = props.imageDetails.session_audit;
  const date_time = moment(new Date(props.imageDetails.timestamp)).format("MMM DD, YYYY hh:mm a");
  const user = session_audit.split("_")[1];
  const store_code = session_audit.split("_")[3];
  const storeInfo = `${address} | ${user} | ${date_time} | ${props.imageDetails.imageName}`;

  const {
    imageDetails,
    annotationDetails
  } = useSelector(state => state.defaultTabStore);
  const {
    showBlurredImages,
    analysisOptions,
    activeAnalysisTab,
    linearAnalysis,
    drillDownAnalysis,
    annotationOptions
  } = useSelector(state => state.analysisStore);
  const imageAnalysisReportData = useSelector(state => state.imageAnalysisStore[props.imageDetails.imageName])
  const [hiData, setHiData] = useState(imageDetails.filter(r => (
    (r.imageName === props.imageDetails.imageName) &&
    (r.lComp === 1) &&
    (r.cComp === 1)
  )));
  const [hiThumbnailData, setHiThumbnailData] = useState({});
  const [pausedHiThumnailData, setPausedHiThumnailData] = useState({});

  const analysisData = imageAnalysisReportData ? imageAnalysisReportData : defaultImageAnalysisState;
  const showBoxes = analysisOptions.showBoxes.selected;
  const blurryImages = analysisOptions.blurryImages.selected;
  const snapshot = analysisOptions.snapshot.selected;
  const imageInfo = analysisOptions.imageInfo.selected;
  const common = annotationOptions.common;
  const falsePositive = annotationOptions.falsePositive;
  const falseNegative = annotationOptions.falseNegative;
  const AI = analysisOptions.AI.selected;
  const HI = analysisOptions.HI.selected;

  const handleScroll = (event) => {
    // zoom in/out on mousewheel scroll (to be added in future)
    const { deltaX, deltaY, deltaMode } = event;
  }

  const handlePopoverPause = () => {
    if (open || popoverPaused) {
      setPopoverPaused(!popoverPaused);
      setPopoverPausedCoords(cursorDim);
      setPausedPopoverData(popoverData);
      setPausedCropCoords(cropCoords);
      setPausedHiThumnailData(hiThumbnailData);
    }
  }

  const handlePopoverLiveDim = (e) => {
    setPopoverLiveDim(e);
  }

  const filterCheck = (boxesDetails, linear, drilldown) => {
    // applying default filters...
    let boxes = boxesDetails.filter(row => (row.isShelf === 0) && (row.secCategory && (row.secCategory[0] !== "DISPLAY")));

    if (activeAnalysisTab === "linearAnalysis") {
      /**
       * Linear analysis is designed in a way that only one type (brand, variant or sku) can be selected at a time
       * this logic filters out the boxes details based on the option avavilable in the selected type.
       */
      const linearSearchOptions = [linear.selectedBrands, linear.selectedVariants, linear.selectedSkus].flat();

      if (linearSearchOptions.length > 0) {
        boxes = boxes.filter(row => (
          linear.selectedBrands.includes(row.ai_data.sku_name) ||
          linear.selectedVariants.includes(row.ai_data.sku_name + "_" + row.ai_data.sub_sku_name) ||
          linear.selectedSkus.includes(row.ai_data.skus)
        ));
        return boxes
      }
    } else if (activeAnalysisTab === "drillDownAnalysis") {
      /**
       * drilldown analysis is designed in a way that, 
       * a brand is selected, and options & boxes for variant are accordingly filtered,
       * then if a variant is selected, options & boxes for skus are accordingly filtered
       */
      if (drilldown.selectedSku.length > 0) {
        const value = drilldown["selectedSku"];
        boxes = boxes.filter(row => value.includes(row.ai_data.skus));
      } else if (drilldown.selectedVariant.length > 0) {
        const value = drilldown["selectedVariant"];
        boxes = boxes.filter(row => value.includes(row.ai_data.sku_name + "_" + row.ai_data.sub_sku_name));
      } else if (drilldown.selectedBrand.length > 0) {
        const value = drilldown["selectedBrand"];
        boxes = boxes.filter(row => value.includes(row.ai_data.sku_name));
      }

      return boxes
    }
    // returnig boxes as it is if no option is selected
    return boxes
  }

  const colorResolver = (linear, drilldown, box_details) => {
    if (activeAnalysisTab === "linearAnalysis") {
      const colorfulSkus = Object.keys(linear.colors);
      if (linear.currentSelectedType === "selectedBrands") {
        if (colorfulSkus.includes(box_details.ai_data.sku_name)) {

          return linear.colors[box_details.ai_data.sku_name];
        } else {
          return "rgb(0, 255, 179)"
        }
      } else if (linear.currentSelectedType === "selectedVariants") {
        if (colorfulSkus.includes(box_details.ai_data.sku_name + "_" + box_details.ai_data.sub_sku_name)) {
          return linear.colors[box_details.ai_data.sku_name + "_" + box_details.ai_data.sub_sku_name];
        } else {
          return "rgb(0, 255, 179)"
        }
      } else if (linear.currentSelectedType === "selectedSkus") {
        if (colorfulSkus.includes(box_details.ai_data.skus)) {
          return linear.colors[box_details.ai_data.skus];
        } else {
          return "rgb(0, 255, 179)"
        }
      } else {
        return "rgb(0, 255, 179)"
      }
    } else {
      const colorfulSkus = Object.keys(drilldown.colors);
      if (drilldown.currentSelectedType === "selectedBrand") {
        if (colorfulSkus.includes(box_details.ai_data.sku_name)) {

          return drilldown.colors[box_details.ai_data.sku_name];
        } else {
          return "rgb(0, 255, 179)"
        }
      } else if (drilldown.currentSelectedType === "selectedVariant") {
        if (colorfulSkus.includes(box_details.ai_data.sku_name + "_" + box_details.ai_data.sub_sku_name)) {
          return drilldown.colors[box_details.ai_data.sku_name + "_" + box_details.ai_data.sub_sku_name];
        } else {
          return "rgb(0, 255, 179)"
        }
      } else if (drilldown.currentSelectedType === "selectedSku") {
        if (colorfulSkus.includes(box_details.ai_data.skus)) {
          return drilldown.colors[box_details.ai_data.skus];
        } else {
          return "rgb(0, 255, 179)"
        }
      } else {
        return "rgb(0, 255, 179)"
      }
    }
  }
  useEffect(() => {
    // 1. applying filters as needed
    let boxes = filterCheck(props.imageDetails.thumbnailsDetails, linearAnalysis, drillDownAnalysis);
    if (boxes.length === 0) {
      setIsBlurredImage(true);
    } else {
      setIsBlurredImage(false);
    }

    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    // const img = new Image();
    // img.crossOrigin = "anonymous";
    // img.src = get_image_url(props.imageDetails.imageName);

    const img = new Image();
    img.crossOrigin = "anonymous";
    const imageUrl = `data:image/jpeg;base64,${props.imageDetails.base64image}`;
    img.src = imageUrl;
    
    img.onload = () => {
      canvas.width = img.width;
      canvas.height = img.height;

      ctx.lineWidth = 2; // Setting a fixed line width for the bounding boxes
      if (boxes.length > 0) {
        ctx.drawImage(img, 0, 0);
      } else {
        ctx.filter = `brightness(30%)`;
        ctx.filter = `blur(35px)`
        ctx.drawImage(img, 0, 0);
        ctx.filter = 'none';
      }
      // Adjusting line width based on window width
      ctx.lineWidth = 3 * (window.innerWidth / 1920); // Adjust 1920 to match your reference width

      let i = 0;
      let HI_data = {};
      if (showBoxes) {
        // figuring out common, false positive & false negative thumbnails, if any
        let commonThumbnails = [];
        let falsePositiveThumbnails = [];
        let falseNegativeThumbnails = [];
        if (HI && (props.imageDetails.isAnnotated === 1)) {
          HI_data = annotationDetails.filter(r => r.imageName === props.imageDetails.imageName)[0];
          commonThumbnails = HI_data.common.map(r => r.thumbnailName);
          falsePositiveThumbnails = HI_data.falsePositive.map(r => r.thumbnailName);
          falseNegativeThumbnails = HI_data.falseNegative.map(r => r.thumbnailName);
        } 
        while (i < boxes.length) {
          // drawing default AI boxes
          let w = boxes[i].xmax - boxes[i].xmin;
          let h = boxes[i].ymax - boxes[i].ymin;
          const color = colorResolver(linearAnalysis, drillDownAnalysis, boxes[i]);
          ctx.strokeStyle = color;
          ctx.strokeRect(boxes[i].xmin, boxes[i].ymin, w, h);
          ctx.font = '30px Arial';
          ctx.fillStyle = 'yellow';

          // Add text to the canvas
          // const text = 'Hello, Canvas!';
          // ctx.fillText(i, boxes[i].xmin, boxes[i].ymin);

          // drawing HI boxes if HI option is enabled
          // also colouring them based on predition types
          if (HI && (props.imageDetails.isAnnotated === 1)) {
            const ai_thumbnail = boxes[i].thumbnailName;
            // console.log('here', commonThumbnails, falsePositiveThumbnails, ai_thumbnail, common.color);
            if (common.selected && commonThumbnails.includes(ai_thumbnail)) {
              ctx.fillStyle = common.color;
              ctx.fillRect(boxes[i].xmin, boxes[i].ymin, w, h);
            } else if (falsePositive.selected && falsePositiveThumbnails.includes(ai_thumbnail)) {
              ctx.fillStyle = falsePositive.color;
              ctx.fillRect(boxes[i].xmin, boxes[i].ymin, w, h);
            } else if (falseNegative.selected && falseNegativeThumbnails.includes(ai_thumbnail)) {
              ctx.fillStyle = falseNegative.color;
              ctx.fillRect(boxes[i].xmin, boxes[i].ymin, w, h);
            }
          }
          i++;
        }
      }

      // using cursor position to figure which thumbnail the cursor is currently hovering on,
      // also, opening & closing popup based on match condition
      if (!popoverPaused) {
        canvas.addEventListener('mousemove', (event) => {
          const x = event.offsetX / props.resize;
          const y = event.offsetY / props.resize;
          const screenX = event.clientX;
          const screenY = event.clientY;

          // Calculate coordinates based on resized dimensions
          const resizedX = x * (canvas.width / props.dim[0]);
          const resizedY = y * (canvas.height / props.dim[1]);
          const match = boxes.filter(box => ((resizedX > box.xmin) && (resizedX < box.xmax)) && (resizedY > box.ymin) && (resizedY < box.ymax));

          if (match.length === 1) {
            setCursorDim([screenX, screenY]);
            setOpen(match.length > 0);
            setPopoverData(match[0]);
            if (match.length > 0) {
              setCropCoords([match[0]["xmin"], match[0]["ymin"], match[0]["xmax"], match[0]["ymax"]]);
              if (hiData.length > 0) {
                const thumbnailBeingHovered = match[0]["thumbnailName"];
                const thumbnailFromHiData = hiData[0].thumbnailsDetails.find(r => r.thumbnailName === thumbnailBeingHovered);
                setHiThumbnailData(thumbnailFromHiData || {});
              } else {
                setHiThumbnailData({});
              }
            }
          } else {
            // Select the box with the minimum area if matches for a coordinate is > 1
            if (match.length > 0) {
              const areas = match.map(row => (row.ymax - row.ymin) * (row.xmax - row.xmin));
              const min_area = _.min(areas);
              const min_area_idx = areas.indexOf(min_area);
              setCursorDim([screenX, screenY]);
              setOpen(match.length > 0);
              setPopoverData(match[min_area_idx]);
              if (match.length > 0) {
                setCropCoords([match[min_area_idx]["xmin"], match[min_area_idx]["ymin"], match[min_area_idx]["xmax"], match[min_area_idx]["ymax"]]);
                if (hiData.length > 0) {
                  const thumbnailBeingHovered = match[min_area_idx]["thumbnailName"];
                  const thumbnailFromHiData = hiData[0].thumbnailsDetails.find(r => r.thumbnailName === thumbnailBeingHovered);
                  setHiThumbnailData(thumbnailFromHiData || {});
                } else {
                  setHiThumbnailData({});
                }
              }
            } else {
              setOpen(false);
            }
          }
        });
      }
      // closing the popup incase cursor leaves the canvas
      canvas.addEventListener("mouseleave", (event) => {
        if (!popoverPaused) {
          setOpen(false);
        }
      })
    };

  }, [popoverPaused, props]);

  useEffect(() => {
    //2. saving image analysis data for taking snapshot 
    if (!isBlurredImage) {
      let updatedAnalysisData = { ...analysisData }
      updatedAnalysisData["imgNo"] = props.imgNo;

      if (activeAnalysisTab === "linearAnalysis") {
        const colors = linearAnalysis.colors;
        const imageInfo = {
          colors: colors
        }
        updatedAnalysisData["imageInfo"] = imageInfo;
        dispatch(imageAnalysisActions.setAnalysisData({
          imageName: props.imageDetails.imageName,
          data: updatedAnalysisData
        }));
      } else if (activeAnalysisTab === "drillDownAnalysis") {
        const colors = drillDownAnalysis.colors;
        const imageInfo = {
          colors: colors
        }
        updatedAnalysisData["imageInfo"] = imageInfo;
        dispatch(imageAnalysisActions.setAnalysisData({
          imageName: props.imageDetails.imageName,
          data: updatedAnalysisData
        }));
      }
    } else {
      dispatch(imageAnalysisActions.removeBlurredImage(props.imageDetails.imageName));
    }
  }, [canvasRef.current])

  // choosing popover view based on popover paused state
  let popoverView
  if (popoverPaused) {
    popoverView = (
      popoverPaused &&
      <PopoverPaused
        display={popoverPaused}
        dim={popoverPausedCoords}
        data={pausedPopoverData}
        cropCoords={pausedCropCoords}
        imageName={props.imageDetails.imageName}
        popoverLiveDim={popoverLiveDim}
        hiThumbnailData={pausedHiThumnailData}
      />
    )
  } else {
    popoverView = (
      (open) &&
      <Popover
        display={open}
        dim={cursorDim}
        data={popoverData}
        cropCoords={cropCoords}
        imageName={props.imageDetails.imageName}
        popoverLiveDim={handlePopoverLiveDim}
        hiThumbnailData={pausedHiThumnailData}
      />
    )
  }

  const downloadImageDetails = () => {
    const data = {
      rawImageData: props.imageDetails,
      hiData: hiData.length > 0 ? hiData : [],
      imageDetailsAll: imageDetails,
      annotationDetailsAll: annotationDetails
    }
    saveJson(data, `${props.imageDetails.imageName}.json`)
  }
  const isAnnotated = props.imageDetails.isAnnotated;
  const annotationText = isAnnotated === 1 ? "A" : "NA";
  const annotationTextFull = isAnnotated === 1 ? "Annotated" : "Non Annotated";

  //details at the top of each img
  const imageInfoHeader = (
    <Stack
      spacing={0.5}
      direction="row"
      className="annotation-info"
    >
      <span className="img-no">{imgNo}</span>
      <BootstrapTooltip title={`Download image details`} placement="top">
        <DownloadIcon
          // className="download-image-details"
          onClick={downloadImageDetails}
          sx={{
            "fontSize": "1.5rem", "backgroundColor": "rgba(0, 0, 0, 0.45)", "borderRadius": "7px", "color": "rgba(255, 255 ,255, 1)", "padding": "0.15rem", "minWidth": "1.5rem", "cursor": "pointer",
          }}
        />
      </BootstrapTooltip>
      <BootstrapTooltip title={`${annotationTextFull}`} placement="top">
        <span className="annotated-or-not">{annotationText}</span>
      </BootstrapTooltip>
    </Stack>
  )

  let toDisplay = true;
  if (HI) {
    // if annotations are on, then 
    // display based on whther images are annotated or not
    toDisplay = !(HI && (isAnnotated === 1));
  } else {
    // if annotations are off
    // display based on blurred images
    toDisplay = (blurryImages && isBlurredImage);
  }

  return (
    <div
      className="image-analysis"
      style={{ display: toDisplay ? "none" : "" }}
    >
      <canvas
        id={props.imgNo}
        onClick={handlePopoverPause}
        onWheel={handleScroll}
        ref={canvasRef}
        style={{ width: `${props.dim[0] * props.resize}px`, height: `${props.dim[1] * props.resize}px` }}
      ></canvas>
      {showBoxes && popoverView}
      {/* details at the top of each img */}
      {imageInfo && imageInfoHeader}
      {/* details at bottom of each img */}
      {imageInfo && <BootstrapTooltip title={`${storeInfo}`} placement="top">
        <span className="store-info">{storeInfo}</span>
      </BootstrapTooltip>}
    </div>
  );
}

